import React from "react";
import { createPortal } from "react-dom";

// A small, generic yes/no confirmation dialog - for actions like logout
// where a plain browser confirm() looks jarring and out of place next to
// the rest of the app's own modal styling.
const ConfirmModal = ({
  show,
  title = "Please confirm",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmVariant = "danger",
  onConfirm,
  onCancel,
}) => {
  if (!show) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onCancel?.();
  };

  return createPortal(
    <>
      <div className="modal-backdrop show" style={{ zIndex: 1040 }} onClick={handleBackdropClick} />
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ zIndex: 1050 }}
        onClick={handleBackdropClick}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content"
            style={{ backgroundColor: "var(--bg-elevated)", color: "var(--text-primary)" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header border-secondary">
              <h5 className="modal-title">{title}</h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={onCancel}
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <p className="mb-0" style={{ color: "var(--text-secondary)" }}>
                {message}
              </p>
            </div>
            <div className="modal-footer border-secondary">
              <button type="button" className="btn btn-secondary" onClick={onCancel}>
                {cancelLabel}
              </button>
              <button
                type="button"
                className={`btn btn-${confirmVariant}`}
                onClick={onConfirm}
              >
                {confirmLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default ConfirmModal;
